import React, { Fragment } from 'react';
import { MenuIcon, SearchIcon } from '@domain-group/fe-co-icon';
import { Button, FullWidth, Modal } from '@domain-group/fe-co-allhomes-design-system';
import { useSendEvent, EventBoundary, usePageViewEvent } from '@domain-group/fe-co-allhomes-analytics';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import AllhomesLogo from '@domain-group/fe-co-allhomes-logo';
import Menu, { SeparatorMenuItem } from './components/menu/menu';
import MembershipButtons from './components/membership-buttons';
import MembershipMenu from './components/membership-menu';
import useMenuState from './components/menu/use-menu-state';
import SearchMenu from './components/search-menu';
import * as styles from './touch-header.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var TouchHeader = _ref => {
  var navigationItems = _ref.navigationItems,
    activeItem = _ref.activeItem,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'compact' : _ref$appearance,
    logoType = _ref.logoType;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _useAllhomesApi = useAllhomesApi(),
    openSignIn = _useAllhomesApi.openSignIn,
    openSignUp = _useAllhomesApi.openSignUp,
    signOut = _useAllhomesApi.signOut,
    isSignedIn = _useAllhomesApi.isSignedIn,
    isIdentityLoaded = _useAllhomesApi.isIdentityLoaded,
    user = _useAllhomesApi.user,
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  usePageViewEvent({
    name: 'load-nav'
  });
  var handleShowNavMenu = isOpen => {
    if (isOpen) {
      sendEvent('load-nav');
    }
  };
  var _useMenuState = useMenuState({
      onChange: handleShowNavMenu
    }),
    showNav = _useMenuState.menuOpen,
    navHandlerProps = _useMenuState.menuHandlerProps,
    closeNav = _useMenuState.closeMenu;
  var _useMenuState2 = useMenuState({
      method: appearance === 'compact' ? 'click' : 'both'
    }),
    showProfile = _useMenuState2.menuOpen,
    profileHandlerProps = _useMenuState2.menuHandlerProps,
    closeProfile = _useMenuState2.closeMenu;
  var _useMenuState3 = useMenuState(),
    showSearch = _useMenuState3.menuOpen,
    searchHandlerProps = _useMenuState3.menuHandlerProps,
    closeSearch = _useMenuState3.closeMenu;
  var homepageLink = getAbsoluteUrl('/');
  var handleSignIn = () => {
    closeNav();
    openSignIn();
  };
  var handleSignUp = () => {
    closeNav();
    openSignUp();
  };
  var handleSignOut = () => {
    closeProfile();
    signOut();
  };
  var handleMenuOnMouseOver = event => {
    if (isSignedIn) {
      sendEvent('load-myah');
      profileHandlerProps.onMouseOver(event);
    }
  };
  var items = navigationItems.flatMap((menuGroup, index) => index === 0 ? menuGroup : [SeparatorMenuItem, ...menuGroup]);
  return ___EmotionJSX(Fragment, null, ___EmotionJSX(EventBoundary, {
    name: "header"
  }, ___EmotionJSX(FullWidth, {
    css: styles.header
  }, ___EmotionJSX("div", {
    css: styles.leftSide
  }, ___EmotionJSX(Button, {
    css: styles.hamburgerButton,
    onClick: navHandlerProps.onClick,
    appearance: "ghostNeutral",
    icon: ___EmotionJSX(MenuIcon, null)
  }), ___EmotionJSX("a", {
    href: homepageLink,
    "aria-label": "Homepage",
    css: styles.logo(logoType)
  }, ___EmotionJSX(AllhomesLogo, {
    variant: logoType,
    css: styles.logoImage(logoType)
  }), logoType === '25-years' && ___EmotionJSX(AllhomesLogo, {
    variant: "color",
    css: styles.fallbackLogoImage
  }))), ___EmotionJSX("div", {
    css: styles.rightSide
  }, ___EmotionJSX(Button, {
    size: "small",
    icon: ___EmotionJSX(SearchIcon, null),
    appearance: "ghostNeutral",
    onClick: searchHandlerProps.onClick
  }), ___EmotionJSX(Menu.Separator, {
    orientation: "row"
  }), ___EmotionJSX("div", {
    css: styles.membershipButton,
    onMouseOver: handleMenuOnMouseOver,
    onFocus: () => {}
  }, ___EmotionJSX(MembershipButtons, {
    appearance: appearance,
    isSignedIn: isSignedIn,
    isIdentityLoaded: isIdentityLoaded,
    user: user,
    onSignInClicked: handleSignIn,
    onSignUpClicked: handleSignUp,
    onProfileMenuClicked: profileHandlerProps.onClick,
    profileExpanded: showProfile
  }), showProfile && appearance === 'full' && ___EmotionJSX("div", {
    css: styles.membershipMenu
  }, ___EmotionJSX(MembershipMenu, {
    user: user,
    onSignoutClick: handleSignOut
  })))))), ___EmotionJSX(EventBoundary, {
    name: "nav"
  }, ___EmotionJSX(Modal, {
    show: showNav,
    onClose: closeNav,
    appearance: {
      desktop: 'left-drawer',
      tablet: 'left-drawer',
      mobile: 'left-drawer'
    },
    title: ___EmotionJSX(Fragment, null, ___EmotionJSX(AllhomesLogo, {
      variant: logoType,
      css: styles.modalLogo(logoType)
    }), logoType === '25-years' && ___EmotionJSX(AllhomesLogo, {
      variant: "color",
      css: styles.modalFallbackLogo
    }))
  }, ___EmotionJSX(Menu, {
    indicator: true,
    activeItem: activeItem,
    items: appearance === 'full' ? items : [...items, SeparatorMenuItem, {
      id: 'membership',
      component: () => ___EmotionJSX("div", {
        css: styles.navMenuMembership
      }, ___EmotionJSX(MembershipButtons, {
        isSignedIn: isSignedIn,
        isIdentityLoaded: isIdentityLoaded,
        user: user,
        onSignInClicked: handleSignIn,
        onSignUpClicked: handleSignUp,
        appearance: "embedded"
      }))
    }],
    orientation: "column"
  }))), ___EmotionJSX(EventBoundary, {
    name: "myah"
  }, appearance === 'compact' ? ___EmotionJSX(Modal, {
    show: showProfile,
    onClose: closeProfile,
    appearance: {
      desktop: 'right-drawer',
      tablet: 'right-drawer',
      mobile: 'right-drawer'
    }
  }, ___EmotionJSX(MembershipMenu, {
    user: user,
    onSignoutClick: handleSignOut
  })) : ___EmotionJSX(Fragment, null)), showSearch && ___EmotionJSX(SearchMenu, {
    listingType: activeItem,
    onClose: closeSearch
  }));
};
export default TouchHeader;